var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Application"}},[_c('router-view',{attrs:{"outside":_vm.outside,"env_ssr":_vm.env_ssr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }